module.exports = __webpack_public_path__ + "static/media/placeholder.4205aae0.svg";